var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _vm._m(0),
    _vm._v(" "),
    _c("td", { staticClass: "nowrap" }, [
      _vm._v(_vm._s(_vm.location.location_name)),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "nowrap" }, [
      _vm.location.pref
        ? _c("span", [_vm._v(_vm._s(this.options.pref[_vm.location.pref]))])
        : _vm._e(),
      _vm._v(" "),
      _vm.location.address
        ? _c("span", [_vm._v(_vm._s(_vm.location.address))])
        : _vm._e(),
      _vm._v(" "),
      _vm.location.tel
        ? _c("span", [_c("br"), _vm._v("TEL. " + _vm._s(_vm.location.tel))])
        : _vm._e(),
      _vm.location.tel && _vm.location.fax
        ? _c("span", [_vm._v(" / ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.location.fax
        ? _c("span", [_vm._v("FAX. " + _vm._s(_vm.location.fax))])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "txt--nowrap" }, [
      _vm._v(_vm._s(_vm.mapTypeName(_vm.location.map_type))),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "txt--nowrap" }, [
      _vm._v(_vm._s(_vm.statusName(_vm.location.location_status))),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "nowrap list_control" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-xs",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.emitChangeEvent(
                _vm.location_index,
                "#dialog_location_change_" + _vm.location_index
              )
            },
          },
        },
        [_c("i", { staticClass: "fa fa-edit" }), _vm._v("変更\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-xs",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.emitDeleteEvent(
                _vm.location_index,
                "#dialog_location_delete_" + _vm.location_index
              )
            },
          },
        },
        [_c("i", { staticClass: "fa fa-trash" }), _vm._v(" 削除\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade inmodal",
        attrs: {
          role: "dialog",
          id: "dialog_location_change_" + _vm.location_index,
          tabindex: "-1",
        },
      },
      [
        _c("app-location-change", {
          attrs: {
            options: _vm.options,
            location: _vm.location,
            location_index: _vm.location_index,
          },
          on: {
            change: _vm.$listeners["change"],
            "change-cancel": _vm.$listeners["change-cancel"],
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade inmodal",
        attrs: {
          role: "dialog",
          id: "dialog_location_delete_" + _vm.location_index,
          tabindex: "-1",
        },
      },
      [
        _c("app-location-delete", {
          attrs: { location: _vm.location, location_index: _vm.location_index },
          on: { delete: _vm.$listeners["delete"] },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "nowrap drag_handle" }, [
      _c("i", { staticClass: "fa fa-align-justify" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }